import { GridCellProps } from '@progress/kendo-react-grid';
import useGridCustomCell from '@components-clean/core/grid/custom-cell';
import { DateCell, EvaluationScoreCell, YesNoCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';

const reviewedStatusKeys = ['Reviewed', 'Unreviewed'];
const { TooltipCell } = useGridCustomCell();
export const GridColumns: GridColumnProps[] = [
    {
        id: 'id',
        field: 'ProductID',
        title: 'ID',
        width: 1,
        minWidth: 60,
        lockedByDefault: true,
    },
    {
        id: 'title',
        field: 'Title',
        title: 'Title',
        width: 1,
        minWidth: 150,
        lockedByDefault: true,
    },
    {
        id: 'riskScore',
        field: 'aa',
        title: 'Risk Score',
        enhancedGroupedColumnToggling: true,
        children: [
            {
                id: 'prevScore',
                field: 'riskScore.prevScore',
                title: 'Previous Score',
                width: 1,
                minWidth: 150,
            },
            {
                id: 'curScore',
                field: 'riskScore.curScore',
                title: 'Current Score',
                width: 1,
                minWidth: 150,
            },
            {
                id: 'direction',
                field: 'riskScore.direction',
                title: 'Direction',
                width: 1,
                minWidth: 150,
            },
        ],
    },
    {
        id: 'description',
        field: 'Description',
        title: 'Description',
        width: 1,
        minWidth: 250,
        filter: 'text',
        cells: {
            data: TooltipCell({
                isCsv: false,
            }),
        },
    },
    {
        id: 'datasetDate',
        field: 'datasetDate',
        title: 'Date',
        width: 1,
        minWidth: 140,
        filter: 'date',
        cells: { data: DateCell },
        cellName: 'DateCell',
    },
    {
        id: 'reviewed',
        field: 'reviewedStatus',
        title: 'Review Status',
        width: 1,
        minWidth: 140,
        filter: 'text',
        lovData: reviewedStatusKeys.map((key) => key),
    },
    {
        title: 'Active',
        id: 'active',
        field: 'isActive',
        cells: { data: YesNoCell },
        filter: 'boolean',
        width: 1,
        minWidth: 110,
    },
    {
        id: 'score',
        field: 'score',
        title: 'Score',
        width: 1,
        minWidth: 110,
        filter: 'numeric',
        filterKey: 'score',
        cells: { data: (props: GridCellProps) => EvaluationScoreCell({ ...props, numberFormat: '0.00' }) },
        ragColumn: true,
        singleValueRagColumn: true,
        evaluationColumn: true,
        multiValueExportTitles: {
            score: 'Score',
            colour: 'Color',
        },
    },
];
